import { useTranslation } from 'react-i18next'
import { getFullName } from 'src/utils/string-formatter.util'
import { useCurrentProject } from 'src/providers/current-project.provider'
import {
  EHumanReviewResolvedBy,
  EHumanReviewResolution,
  type THumanReviewRequest,
} from '../human-review-requests.type'

export type ResolvedRequest = THumanReviewRequest & { resolution: EHumanReviewResolution; resolvedAt: string }

export const isResolvedRequest = (reviewRequest: THumanReviewRequest): reviewRequest is ResolvedRequest =>
  reviewRequest.resolution !== null && reviewRequest.resolvedAt !== null

export const ResolutionNote = ({ request }: { request: ResolvedRequest }) => {
  const { t, i18n } = useTranslation()
  const { users } = useCurrentProject()

  const resolvedByUser =
    request.resolvedBy === EHumanReviewResolvedBy.USER
      ? users.find((user) => user.id === request.resolvedByUserId)
      : undefined
  const resolutionSentenceParams = {
    resolvedBy: request.resolvedBy ?? 'NONE',
    name:
      resolvedByUser && (resolvedByUser.firstname || resolvedByUser.lastname)
        ? getFullName(resolvedByUser)
        : undefined,
    date: new Date(request.resolvedAt).toLocaleDateString(i18n.language, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }),
  }

  const resolutionSentenceByResolution: Record<EHumanReviewResolution, string> = {
    [EHumanReviewResolution.PROCESSED]: t(
      'pages.dashboard.human-review-requests.problems.resolution-summary.sentence-processed',
      resolutionSentenceParams,
    ),
    [EHumanReviewResolution.UNREACHABLE]: t(
      'pages.dashboard.human-review-requests.problems.resolution-summary.sentence-unreachable',
      resolutionSentenceParams,
    ),
    [EHumanReviewResolution.CONTACTED]: t(
      'pages.dashboard.human-review-requests.problems.resolution-summary.sentence-contacted',
      resolutionSentenceParams,
    ),
  }

  return (
    <div className="c-mt-2 c-text-sm c-text-grey-700">
      <p className="c-m-0">{resolutionSentenceByResolution[request.resolution]}</p>
      {request.resolutionComment && (
        <p className="c-m-0">
          {t('pages.dashboard.human-review-requests.problems.resolution-summary.comment-label')} :{' '}
          {request.resolutionComment}
        </p>
      )}
    </div>
  )
}
